import React, { FC, useState, useEffect } from 'react';
import './style.scss';

interface Props {
  icon?: string;
  label: string;
  labelPosition?: string;
  styleDef?: React.CSSProperties;
  type?: string;
  required?: string;
}

const DefaultLabel: FC<Props> = ({
  icon,
  label,
  labelPosition = '',
  styleDef,
  type,
  required = ''
}) => {
  return (
    <div className='_title_label_def_div'>
      <div className={['_label_div', labelPosition].join(' ')} style={styleDef}>
        <div className='_text'>{label}</div>
        {required !== '' ? <div className='_required'>{required}</div> : ''}
      </div>
    </div>
  );
};

export default DefaultLabel;
